var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayer02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0527 60.7117V58.2437C20.0527 50.0748 26.6915 43.436 34.8604 43.436H44.7322C52.9011 43.436 59.5399 50.0748 59.5399 58.2437V60.7117",
    stroke: "#414141",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7961 36.0322C34.3419 36.0322 29.9243 31.6145 29.9243 26.1604C29.9243 20.7062 34.3419 16.2886 39.7961 16.2886C45.2503 16.2886 49.6679 20.7062 49.6679 26.1604C49.6679 31.6145 45.2503 36.0322 39.7961 36.0322Z",
    stroke: "#414141",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.2041,
    cy: 38.5,
    r: 37,
    stroke: "#FFF9F9",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer02);
export default __webpack_public_path__ + "static/media/player02.0677518feffdc70c4756866c445370e2.svg";
export { ForwardRef as ReactComponent };